import { render, staticRenderFns } from "./swiper-button.vue?vue&type=template&id=31240cff&scoped=true&"
import script from "./swiper-button.vue?vue&type=script&lang=js&"
export * from "./swiper-button.vue?vue&type=script&lang=js&"
import style0 from "./swiper-button.vue?vue&type=style&index=0&id=31240cff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31240cff",
  null
  
)

export default component.exports